module.exports = __webpack_public_path__ + "media/2.5240ba1a.mp3";